import showdown from "showdown";

/**
 * @param {string} html
 */
export const htmlToMarkdown = (html = "") => {
  // Remove br tags to avoid extra line breaks
  let processedHtml = html
    .replace(/<br\s*\/?>/gi, "")
    .replaceAll(`<span class="ql-ui" contenteditable="false"></span>`, "");

  // Remove empty paragraphs that result from removing br tags
  processedHtml = processedHtml.replace(/<p>\s*<\/p>/gi, "");

  // Convert bullet lists from ol to ul tags
  // This handles the case where <ol><li data-list="bullet"> is used for bullet lists
  processedHtml = processedHtml.replace(/<ol>((?:<li data-list="bullet">[^]*?<\/li>)+)<\/ol>/g, (_match, listItems) => {
    // Replace the ol tags with ul tags
    return `<ul>${listItems}</ul>`;
  });

  const converter = new showdown.Converter();
  const markdown = converter.makeMarkdown(processedHtml);

  // Fix escaped dots in numbered lists, escaped block quotes, and remove extra newlines
  return markdown.replace(/\\\./g, ".").replace(/\\>/g, ">").replaceAll(`<!-- -->`, "").trim(); // Remove leading/trailing whitespace
};

export const markdown2html = (markdown = "") => {
  const converter = new showdown.Converter();
  return converter.makeHtml(markdown);
};
